import React from "react";
import bg from "images/section-bg-licensing.jpg";
import { HelpWithLicenseContainer } from "./styles";
import { Button } from "@material-ui/core";
import { Link } from "react-router-dom";

function HelpWithLicense() {
  return (
    <HelpWithLicenseContainer>
      <h2 className="license-title">Need help finding the right video or license?</h2>
      <a href="https://campaign.jukinmedia.com/jmlicensing#element-330">
        <Button className="license-button" variant="contained">
          Get Started
        </Button>
      </a>
    </HelpWithLicenseContainer>
  );
}

export default HelpWithLicense;
